import React from 'react'

export const DashboardSkeleton = () => {
  return (
    <div className="row justify-content-center">
      <div className="col-11">
        <div className="mt-4 pt-4 pb-3">
          <h1 className="d-lg-flex justify-content-between">
            <span className="h1 mb-md-0 w-50 animate mb-5"></span>
            <div className="d-none d-lg-inline h5 ms-md-auto w-25 animate"></div>
          </h1>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="db-header animate"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-8 mb-xl-0 mb-3" style={{ minHeight: '450px' }}>
            <div className="animate h-100 my-3 shadow-sm"></div>
          </div>
          <div className="col-xl-4" style={{ minHeight: '450px' }}>
            <div className="animate h-100 my-3 shadow-sm"></div>
          </div>
        </div>
      </div>
    </div>
  )
}
